(() => {
  'use strict';

  const variantInputSelector =
    'form[action*="/cart/add"] input[name="id"], product-form input[name="id"], product-form-component input[name="id"]';

  function bottleCount(card, fallbackIndex) {
    const source = `${card.dataset.optionValue || ''} ${card.textContent || ''}`.toLowerCase();

    if (source.includes('3 bottle')) return 3;
    if (source.includes('2 bottle')) return 2;
    if (source.includes('1 bottle')) return 1;
    return fallbackIndex + 1;
  }

  function parseMoney(text) {
    let value = String(text || '').replace(/\s/g, '').replace(/[^0-9,.-]/g, '');
    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');

    if (comma > -1 && dot > -1) {
      const decimal = comma > dot ? ',' : '.';
      value = value
        .replace(decimal === ',' ? /\./g : /,/g, '')
        .replace(decimal, '.');
    } else if (comma > -1) {
      value = value.length - comma - 1 <= 2 ? value.replace(',', '.') : value.replace(/,/g, '');
    }

    return Number(value) || 0;
  }

  function formatMoney(value, fallbackText) {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
      }).format(value);
    } catch (_error) {
      const symbol = String(fallbackText || '$').replace(/[\d\s.,-]/g, '') || '$';
      return `${symbol}${value.toFixed(2)}`;
    }
  }

  function setBundleCopy(card, count, singlePrice) {
    const priceNode = card.querySelector('.tf-offer-now');
    const nameNode = card.querySelector('.tf-offer-name');
    const priceRoot = card.querySelector('.tf-offer-price');
    const price = parseMoney(priceNode?.textContent);
    const regularPrice = singlePrice * count;
    const savings = count > 1 && regularPrice > 0
      ? Math.max(0, Math.round((1 - price / regularPrice) * 100))
      : 0;
    const totalSavings = Math.max(0, regularPrice - price);

    card.dataset.bottleCount = String(count);
    card.dataset.savingsPercent = String(savings);
    card.dataset.regularPriceText = savings
      ? formatMoney(regularPrice, priceNode?.textContent)
      : '';

    card.querySelectorAll('.tf-offer-badge').forEach((node) => node.remove());

    if (nameNode) {
      nameNode.replaceChildren(document.createTextNode(`${count} Bottle${count === 1 ? '' : 's'}`));

      if (count >= 1 && count <= 3) {
        const badge = document.createElement('span');
        badge.className = `tf-offer-badge tf-offer-badge--${count === 1 ? 'trial' : count === 2 ? 'popular' : 'value'}`;
        badge.textContent = count === 1 ? 'Trial Pack' : count === 2 ? 'Most Popular' : 'Best Value';
        card.append(badge);
      }
    }

    let detail = card.querySelector('.tf-offer-save');
    if (!detail && nameNode?.parentElement) {
      detail = document.createElement('p');
      detail.className = 'tf-offer-save';
      nameNode.parentElement.append(detail);
    }

    if (detail && price > 0) {
      const unitPrice = document.createElement('span');
      unitPrice.className = 'tf-offer-unit-price';
      unitPrice.textContent = `${formatMoney(price / count, priceNode?.textContent)} each`;
      detail.replaceChildren(unitPrice);

      if (count === 1) {
        const separator = document.createElement('span');
        separator.className = 'tf-offer-save-separator';
        separator.textContent = '·';

        const trialNote = document.createElement('span');
        trialNote.className = 'tf-offer-trial-note';
        trialNote.textContent = 'No bundle savings';
        detail.append(separator, trialNote);
      } else if (savings && totalSavings > 0) {
        const separator = document.createElement('span');
        separator.className = 'tf-offer-save-separator';
        separator.textContent = '·';

        const deal = document.createElement('span');
        deal.className = 'tf-offer-deal';
        deal.textContent = `Save ${formatMoney(totalSavings, priceNode?.textContent)}`;
        detail.append(separator, deal);
      }
    }

    card.querySelectorAll('.tf-offer-percent').forEach((node) => node.remove());

    let comparePrice = card.querySelector('.tf-offer-was');
    if (savings && priceRoot && priceNode) {
      if (!comparePrice) {
        comparePrice = document.createElement('s');
        comparePrice.className = 'tf-offer-was';
      }
      comparePrice.textContent = formatMoney(regularPrice, priceNode.textContent);
      priceNode.before(comparePrice);

      const percent = document.createElement('span');
      percent.className = 'tf-offer-percent';
      percent.textContent = `SAVE ${savings}%`;
      priceNode.after(percent);
    } else {
      comparePrice?.remove();
    }
  }

  function setDisplayedPrice(productRoot, priceText) {
    if (!priceText) return;

    productRoot.querySelectorAll('product-price').forEach((root) => {
      root.querySelectorAll('.price-item--sale.price, .price__regular .price, [data-product-price]').forEach((node) => {
        node.textContent = priceText;
      });
      root.querySelectorAll('.compare-at-price, s').forEach((node) => {
        node.hidden = true;
        node.style.display = 'none';
      });
    });
  }

  function setVariantInputs(productRoot, card) {
    const variantId = card.dataset.variantId || '';
    const optionValue = card.dataset.optionValue || '';
    if (!variantId) return;

    productRoot.querySelectorAll(variantInputSelector).forEach((input) => {
      input.value = variantId;
    });

    productRoot.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]').forEach((radio) => {
      radio.checked = radio.dataset.variantId === variantId || radio.value === optionValue;
    });
  }

  function updateSticky(card, priceText) {
    const sticky = document.querySelector('[data-tf-sticky-atc]');
    if (!sticky) return;

    const stickyTitle = sticky.querySelector('.tf-sticky-atc__copy strong');
    const stickyPrice = sticky.querySelector('[data-tf-sticky-price]');
    const stickyCompare = sticky.querySelector('[data-tf-sticky-compare]');
    const stickySave = sticky.querySelector('[data-tf-sticky-save]');
    const stickySubmit = sticky.querySelector('[data-tf-sticky-submit]');
    const count = Number(card.dataset.bottleCount) || 1;
    const savings = Number(card.dataset.savingsPercent) || 0;
    const regularPriceText = card.dataset.regularPriceText || '';

    if (stickyTitle) {
      if (!sticky.dataset.tfBaseTitle) sticky.dataset.tfBaseTitle = stickyTitle.textContent.trim();
      const shortTitle = sticky.dataset.tfBaseTitle.replace(/\s+Liquid$/i, '');
      stickyTitle.textContent = `${shortTitle} · ${count} Bottle${count === 1 ? '' : 's'}`;
    }
    if (stickyPrice) stickyPrice.textContent = priceText;
    if (stickyCompare) {
      stickyCompare.textContent = regularPriceText;
      stickyCompare.hidden = !savings;
    }
    if (stickySave) {
      stickySave.textContent = savings ? `SAVE ${savings}%` : '';
      stickySave.hidden = !savings;
    }
    if (stickySubmit && !stickySubmit.classList.contains('is-loading')) {
      const packLabel = `${count} BOTTLE${count === 1 ? '' : 'S'}`;
      stickySubmit.textContent = `ADD ${packLabel}`;
      stickySubmit.setAttribute('aria-label', `Add ${packLabel.toLowerCase()} to cart`);
    }
  }

  function mediaIndexForCount(count, thumbs) {
    const numberWord = count === 1 ? 'one' : count === 2 ? 'two' : 'three';
    const matchedIndex = thumbs.findIndex((thumb) => {
      const copy = `${thumb.dataset.alt || ''} ${thumb.querySelector('img')?.alt || ''}`.toLowerCase();
      return copy.includes(`${count} bottle`) || copy.includes(`${numberWord} bottle`);
    });

    if (matchedIndex >= 0) return matchedIndex;
    if (count === 2 && thumbs.length > 3) return 3;
    if (count === 3 && thumbs.length > 4) return 4;
    return 0;
  }

  function updateDesktopMedia(count) {
    const gallery = document.querySelector('.toefix-desktop-gallery--nailcare');
    if (!gallery) return;

    const thumbs = Array.from(gallery.querySelectorAll('[data-toefix-thumb]'));
    const thumb = thumbs[mediaIndexForCount(count, thumbs)];
    const mainImage = gallery.querySelector('.toefix-desktop-gallery__image');
    const mainSource = gallery.querySelector('.toefix-desktop-gallery__source');
    const newImage = thumb?.dataset.full || '';
    if (!thumb || !mainImage || !newImage) return;

    if (mainSource) mainSource.setAttribute('srcset', newImage);
    mainImage.setAttribute('src', newImage);
    mainImage.removeAttribute('srcset');
    mainImage.setAttribute('alt', thumb.dataset.alt || '');

    thumbs.forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  function updateMobileMedia(count) {
    const track = document.querySelector('.toefix-mobile-native-gallery--nailcare .toefix-mobile-native-gallery__track');
    if (!track) return;

    const slides = Array.from(track.children);
    const mediaIndex = mediaIndexForCount(count, slides);
    const targetSlide = slides[mediaIndex];
    if (targetSlide) track.scrollLeft = targetSlide.offsetLeft;
  }

  function updateBundleMedia(count) {
    if (window.matchMedia('(min-width: 750px)').matches) updateDesktopMedia(count);
    else updateMobileMedia(count);
  }

  function applySelection(box, cards, card) {
    const productRoot = box.closest('.product-information, product-info, .product-details, .product__info-wrapper') || document;
    const priceText = card.querySelector('.tf-offer-now')?.textContent?.trim() || '';
    const count = Number(card.dataset.bottleCount) || bottleCount(card, cards.indexOf(card));

    cards.forEach((item) => {
      const active = item === card;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    setVariantInputs(productRoot, card);
    setDisplayedPrice(productRoot, priceText);
    updateSticky(card, priceText);
    updateBundleMedia(count);
  }

  function init() {
    document.querySelectorAll('.tf-offer-box').forEach((box) => {
      const cards = Array.from(box.querySelectorAll('.tf-offer-card'));
      if (!cards.length || box.dataset.tfInstantBundles === 'true') return;

      const entries = cards.map((card, index) => ({
        card,
        count: bottleCount(card, index),
        price: parseMoney(card.querySelector('.tf-offer-now')?.textContent),
      }));
      const priceByCount = new Map(entries.map((entry) => [entry.count, entry.price]));
      const singlePrice = priceByCount.get(1) || entries[0]?.price || 0;

      entries.forEach(({ card, count }) => {
        setBundleCopy(card, count, singlePrice);
      });

      const defaultCard = cards.find((card) => card.dataset.bottleCount === '2' && !card.disabled)
        || cards.find((card) => !card.disabled);
      if (defaultCard) applySelection(box, cards, defaultCard);

      box.dataset.tfInstantBundles = 'true';
      box.addEventListener('click', (event) => {
        const card = event.target.closest?.('.tf-offer-card');
        if (!card || card.disabled || !box.contains(card)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        applySelection(box, cards, card);
      }, true);
    });
  }

  init();
})();
